import React from "react";
import { officeBearers, executiveMembers, advisors } from "../../data/teamData";

const MemberCard = ({ member, size = "normal" }) => {
  const isLarge = size === "normal";
  const avatarSize = isLarge ? "h-24 w-24" : "h-16 w-16";

  return (
    <article className="rounded-lg border border-[var(--smym-line)] bg-[var(--smym-paper)] p-4 text-center sm:p-5">
      {member.photo ? (
        <div
          className={`${avatarSize} mx-auto mb-3 overflow-hidden rounded-full border-2 border-[var(--smym-line)]`}
        >
          <picture className="contents">
            {member.photoWebp ? (
              <source srcSet={member.photoWebp} type="image/webp" />
            ) : null}
            <img
              src={member.photo}
              alt={member.name}
              loading="lazy"
              className="h-full w-full object-cover"
              style={{ objectPosition: member.photoPosition || "center" }}
              onError={(e) => {
                const frame = e.currentTarget.closest("div");
                if (!frame) return;
                frame.innerHTML = `<span class="flex h-full w-full items-center justify-center text-lg font-semibold text-[var(--smym-accent)]">${member.name
                  .split(" ")
                  .map((n) => n[0])
                  .join("")
                  .slice(0, 2)}</span>`;
              }}
            />
          </picture>
        </div>
      ) : (
        <div
          className={`${avatarSize} mx-auto mb-3 flex items-center justify-center rounded-full bg-[var(--smym-accent-soft)]`}
        >
          <span className="text-lg font-semibold text-[var(--smym-accent)]">
            {member.name
              .split(" ")
              .map((n) => n[0])
              .join("")
              .slice(0, 2)}
          </span>
        </div>
      )}
      <h4
        className={`font-semibold text-[var(--smym-ink)] ${isLarge ? "text-base" : "text-sm"}`}
      >
        {member.name}
      </h4>
      <p
        className={`mt-0.5 font-medium text-[var(--smym-accent)] ${isLarge ? "text-sm" : "text-xs"}`}
      >
        {member.position}
      </p>
    </article>
  );
};

const TeamSection = () => {
  return (
    <section
      id="team"
      className="smym-section border-t border-[var(--smym-line)] bg-[var(--smym-paper-2)] px-4 sm:px-6"
    >
      <div className="mx-auto max-w-6xl">
        <h2 className="smym-section-title mb-3 text-center">Our leadership</h2>
        <p className="mx-auto mb-12 text-center text-[var(--smym-ink-muted)] [max-width:40ch]">
          Office bearers, executive committee, and advisors
        </p>

        <div className="mb-14">
          <h3 className="mb-6 text-lg font-semibold text-[var(--smym-ink)]">
            Office bearers
          </h3>
          <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 lg:gap-5">
            {officeBearers.map((member, idx) => (
              <MemberCard key={idx} member={member} />
            ))}
          </div>
        </div>

        <div className="mb-14">
          <h3 className="mb-6 text-lg font-semibold text-[var(--smym-ink)]">
            Executive committee
          </h3>
          <div className="grid grid-cols-2 gap-3 md:grid-cols-4 lg:grid-cols-5">
            {executiveMembers.map((member, idx) => (
              <MemberCard key={idx} member={member} size="small" />
            ))}
          </div>
        </div>

        <div>
          <h3 className="mb-6 text-lg font-semibold text-[var(--smym-ink)]">
            Advisors
          </h3>
          <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-5">
            {advisors.map((member, idx) => (
              <MemberCard key={idx} member={member} size="small" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
